import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ForWhoSection } from './components/ForWhoSection';
import { PainPointsSection } from './components/PainPointsSection';
import { WhatIsIncludedSection } from './components/WhatIsIncludedSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { EarlyOfferSection } from './components/EarlyOfferSection';
import { ModulesSection } from './components/ModulesSection';
import { SocialProofSection } from './components/SocialProofSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen font-sans text-brand-dark selection:bg-brand-amber/30" style={{
    background: 'radial-gradient(ellipse at 50% 50%, rgba(168, 85, 247, 0.35) 0%, rgba(139, 92, 246, 0.22) 20%, rgba(88, 28, 135, 0.15) 40%, #000000 70%)',
    backgroundColor: '#000000'
  }} data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPointsSection data-id="element-3" />
        <ForWhoSection data-id="element-4" />
        <WhatIsIncludedSection data-id="element-5" />
        <EarlyOfferSection data-id="element-6" />
        <BeforeAfterSection data-id="element-7" />
        <ModulesSection data-id="element-8" />
        <SocialProofSection data-id="element-9" />
        <OfferSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}